import PropTypes from 'prop-types'
import Logout from './logout'
import { useIsLoggedIn } from '../../../zustand/authentication/use-auth-store'

const ForceLogout = ({ children }) => {
  const isLoggedIn = useIsLoggedIn()

  if (isLoggedIn) {
    return <Logout />
  }
  return <>{children}</>
}

ForceLogout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
}

export default ForceLogout
